import { event } from "vue-gtag";
import store from "@/store/index.js";
import { isProduction, isStaging } from "@/utils/env";

/**
 * Sends a gtag event only if the active user is not an employee
 * and the environment is production or staging.
 *
 * @param {object} [options]
 * @param {boolean} [options.includeEmployees] also send the event for
 *   employees. Off by default so internal use does not skew the usual product
 *   metrics — turn it on only for events whose population is largely internal,
 *   and keep a `customer_type` param so the two stay separable in GA4.
 */
export function trackEvent(eventName, params, { includeEmployees = false } = {}) {
  if (!isProduction && !isStaging) return;
  if (!includeEmployees && store.getters.activeUserIsEmployee) return;
  event(eventName, params);
}
